"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.VciLogger = void 0;
const tslib_1 = require("tslib");
/* eslint-disable */
const moment_1 = tslib_1.__importDefault(require("moment"));
const vci_models_1 = require("@ownportal/vci-models");
const _ = tslib_1.__importStar(require("lodash"));
const react_device_detect_1 = require("react-device-detect");
const SplunkLogger_1 = tslib_1.__importDefault(require("./SplunkLogger"));
class VciLogger {
}
exports.VciLogger = VciLogger;
_a = VciLogger;
VciLogger.ConsoleLogger = (ctx, level, status, logMessage, functionName, correlationId, parentFunctionName, processName, sourceApp, widgetName) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const logData = new vci_models_1.LogData();
    logData.Environment = process.env.AWS_ENV;
    logData.TimeStamp = (0, moment_1.default)().valueOf().toString();
    logData.ContextualData = ctx;
    logData.Level = level;
    logData.Status = status;
    logData.Message = logMessage;
    logData.FunctionName = functionName;
    logData.CorrelationId = correlationId;
    logData.ParentFunctionName = parentFunctionName;
    logData.ProcessName = processName;
    logData.SourceApp = sourceApp;
    logData.WidgetName = widgetName;
    const loggerData = JSON.stringify(logData);
    if (level === "ERROR" /* LogLevel.ERROR */) {
        console.error("\n" + "AwsSplunklogData:" + loggerData);
    }
    if (level === "INFO" /* LogLevel.INFO */) {
        console.info("\n" + "AwsSplunklogData:" + loggerData);
    }
    if (level === "WARN" /* LogLevel.WARN */) {
        console.warn("\n" + "AwsSplunklogData:" + loggerData);
    }
});
VciLogger.SplunkLogInfo = (appName, actionName, screenName, accountInfo, splunkDetails) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const splunkLogger = SplunkLogger_1.default.setLogger(splunkDetails.SplunkToken, splunkDetails.SplunkUrl);
    splunkLogger.info(createLogPayload(appName, actionName, screenName, "none", accountInfo));
});
VciLogger.SplunkLogError = (appName, actionName, screenName, error, accountInfo, splunkDetails) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const splunkLogger = SplunkLogger_1.default.setLogger(splunkDetails.SplunkToken, splunkDetails.SplunkUrl);
    splunkLogger.error(createLogPayload(appName, actionName, screenName, error, accountInfo));
});
VciLogger.SplunkLogWarning = (appName, functionName, params, splunkDetails) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const splunkLogger = SplunkLogger_1.default.setLogger(splunkDetails.SplunkToken, splunkDetails.SplunkUrl);
    splunkLogger.warn(createLogPayload(appName, functionName, params));
});
VciLogger.SplunkLogFatal = (appName, functionName, params, splunkDetails) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const splunkLogger = SplunkLogger_1.default.setLogger(splunkDetails.SplunkToken, splunkDetails.SplunkUrl);
    splunkLogger.fatal(createLogPayload(appName, functionName, params));
});
function createLogPayload(appName, actionName, screenName, error, accountInfo) {
    if (!_.isEmpty(error)) {
        delete error.config;
    }
    const payload = {
        application: appName,
        correlationId: accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.correlationId,
        accountNumber: accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.accountNumber,
        partyId: accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.partyId,
        country: accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.country,
        brand: accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.brand,
        sourceApp: accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.source,
        timeStamp: new Date(),
        screen: screenName,
        action: actionName,
        error: error,
        deviceInfo: (0, react_device_detect_1.deviceDetect)(),
        username: accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.username,
        hosturl: accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.hosturl,
    };
    return JSON.parse(JSON.stringify(payload));
}
//# sourceMappingURL=logger.js.map